export default "<span class=\"copy-snack\">\n   Copied example.\n</span>\n";